import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import StatusBadge from '../../components/common/StatusBadge';
import { formatNumero } from '../../utils/fmt';
import * as api from '../../api/painelCadastros';

function StatCard({ valor, label, sub, cor, to }) {
  const content = (
    <div className="cjc-stat-card h-100">
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={{ color: cor || 'var(--cjc-primary)' }}>{valor ?? '—'}</div>
      {sub && <div className="text-muted" style={{ fontSize: 12, marginTop: 2 }}>{sub}</div>}
    </div>
  );
  return to ? <Link to={to} style={{ textDecoration: 'none' }}>{content}</Link> : content;
}

function SecaoTitulo({ children }) {
  return (
    <h2 className="h6 fw-bold mt-4 mb-3" style={{ color: 'var(--cjc-primary)', fontFamily: "'Fira Sans', sans-serif" }}>
      {children}
    </h2>
  );
}

export default function PainelCadastros() {
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    api.getPainelCadastros()
      .then(r => setDados(r.data))
      .catch(() => setErro('Erro ao carregar o painel de cadastros. Tente novamente.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;
  if (erro) return <div className="alert alert-danger">{erro}</div>;
  if (!dados) return null;

  const global = dados.escopo === 'global';

  return (
    <div>
      <PageHeader
        titulo="Painel de Cadastros"
        subtitulo={global ? 'Toda a plataforma (todas as empresas)' : `Empresa: ${dados.nome_empresa || '—'}`}
      />

      {global && (
        <>
          <SecaoTitulo>Plataforma</SecaoTitulo>
          <div className="row g-3">
            <div className="col-6 col-lg-3">
              <StatCard valor={dados.empresas_ativas} label="Empresas Ativas" sub={`${dados.total_empresas} cadastradas no total`} to="/empresas" />
            </div>
          </div>
        </>
      )}

      <SecaoTitulo>Clientes e Usuários</SecaoTitulo>
      <div className="row g-3">
        <div className="col-6 col-lg-3">
          <StatCard valor={dados.total_clientes} label="Clientes Finais" sub={`PF: ${dados.clientes_pf} · PJ: ${dados.clientes_pj}`} to="/clientes" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard valor={dados.usuarios_operador} label="Usuários Operador" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard valor={dados.usuarios_gestor} label="Usuários Gestor" />
        </div>
      </div>

      <SecaoTitulo>Catálogo</SecaoTitulo>
      <div className="row g-3">
        <div className="col-6 col-lg-3">
          <StatCard valor={dados.total_modelos} label="Modelos" sub={`Geral: ${dados.modelos_gerais} · Exclusivo: ${dados.modelos_exclusivos}`} to="/modelos" />
        </div>
        <div className="col-6 col-lg-3"><StatCard valor={dados.total_tipos} label="Tipos de Uniforme" to="/tipos-uniforme" /></div>
        <div className="col-6 col-lg-3"><StatCard valor={dados.total_cores} label="Cores Cadastradas" to="/cores-uniforme" /></div>
        <div className="col-6 col-lg-3"><StatCard valor={dados.total_tamanhos} label="Tamanhos Cadastrados" to="/tamanhos-uniforme" /></div>
      </div>

      <SecaoTitulo>Estoque &amp; Produção</SecaoTitulo>
      <div className="row g-3">
        <div className="col-6 col-lg-3">
          <StatCard valor={formatNumero(dados.estoque_disponivel)} label="Unidades em Estoque" to="/estoque" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard valor={formatNumero(dados.estoque_reservado_fabricacao)} label="Reservado p/ Fabricação" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard valor={dados.estoque_posicoes_zeradas} label="Posições com Estoque Zerado"
            cor={dados.estoque_posicoes_zeradas > 0 ? 'var(--cjc-accent)' : undefined} to="/estoque" />
        </div>
      </div>
      <div className="row g-3 mt-1">
        {[
          ['aberta', dados.demandas_aberta],
          ['em_producao', dados.demandas_em_producao],
          ['parcialmente_atendida', dados.demandas_parcialmente_atendida],
          ['atendida', dados.demandas_atendida],
        ].map(([status, valor]) => (
          <div className="col-6 col-lg-3" key={status}>
            <div className="cjc-stat-card h-100">
              <div className="stat-label d-flex align-items-center gap-2">
                Demandas <StatusBadge status={status} />
              </div>
              <div className="stat-value">{valor}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
